export function getCookie(name) {
  const cookieValue = document.cookie
    .split('; ')
    .find(row =>
      row.startsWith(name)
    )?.split('=')[1];
  return cookieValue;
}

export function clearCookie(name) {
  const cookieRegex = new RegExp(`${name}=.*?;`);
  document.cookie=document.cookie.replace(cookieRegex, `${name}=;`);
}
